import {publicGet} from './publicClient';
import type {ProductListResponse, StorefrontProduct} from '../types';
import settings from '@/settings';

function resolveImageUrl(url: string | null): string | null {
    if (!url) return null;
    if (url.startsWith('/api/')) {
        return new URL(url, settings.apiURL).toString();
    }
    return url;
}

function resolveProduct(p: StorefrontProduct): StorefrontProduct {
    return {...p, image_url: resolveImageUrl(p.image_url)};
}

export const ShopService = {
    async getProducts(params?: {
        category?: string;
        sort?: string;
        page?: number;
        limit?: number;
    }): Promise<ProductListResponse> {
        const query = new URLSearchParams();
        if (params?.category) query.set('category', params.category);
        if (params?.sort) query.set('sort', params.sort);
        if (params?.page) query.set('page', String(params.page));
        if (params?.limit) query.set('limit', String(params.limit));
        const qs = query.toString();
        const res = await publicGet<ProductListResponse>(`/api/shop/products${qs ? `?${qs}` : ''}`);
        return {...res, products: res.products.map(resolveProduct)};
    },

    async getProduct(slug: string): Promise<{product: StorefrontProduct}> {
        const res = await publicGet<{product: StorefrontProduct}>(`/api/shop/products/${slug}`);
        return {product: resolveProduct(res.product)};
    },

    async getCategories(): Promise<{categories: string[]}> {
        return publicGet<{categories: string[]}>('/api/shop/categories');
    },
};
